import clsx from 'clsx';
import { Col, Row, Container, Space } from '@ag1/ui';
import { SanityKeyed, SocialMedia as SocialMediaProps } from 'types/studio/studio';
import { getSectionPaddingClasses } from 'shared/utils/getSectionPaddingClasses';
import SocialMediaHeadlineAndSubtitle from './SocialMediaHeadlineAndSubtitle/SocialMediaHeadlineAndSubtitle';
import SocialMediaImage from './SocialMediaImage/SocialMediaImage';
import SocialMediaProfileLink from './SocialMediaProfileLink/SocialMediaProfileLink';
import styles from './SocialMedia.module.scss';
import { CommonSectionProps } from '../types';

const SocialMedia = ({
  _type: sectionType,
  _key: key,
  headline,
  subtitle,
  images,
  bgColor,
  theme,
  socialProfile,
  padding,
  visibleOnPageLoad
}: SanityKeyed<SocialMediaProps> & CommonSectionProps) => {
  if (!headline || !socialProfile || !images) {
    return null;
  }

  const filteredImages = images.filter((image) => image.baseImage && image.imageLink);

  return (
    <div className={clsx(styles.root, bgColor === 'grey' && styles.bgGrey)}>
      <Container narrow id={key}>
        <Space
          top={{ xxs: 40, s: 60, m: 80, l: 100 }}
          bottom={{ xxs: 40, s: 60, m: 80, l: 100 }}
          className={clsx(getSectionPaddingClasses(styles, padding))}>
          <SocialMediaHeadlineAndSubtitle headline={headline} subtitle={subtitle} theme={theme} />
          <Row className={styles.imagesRow}>
            {filteredImages.map((image) => (
              <Col key={image._key} span={{ xxs: 6, l: 3 }}>
                <SocialMediaImage
                  baseImage={image.baseImage}
                  imageLink={image.imageLink}
                  sectionType={sectionType}
                  sizes={{ xxs: 6, l: '350px' }}
                  visibleOnPageLoad={visibleOnPageLoad}
                />
              </Col>
            ))}
          </Row>
          {socialProfile.link && socialProfile.linkText && (
            <SocialMediaProfileLink socialProfile={socialProfile} bgColor={bgColor} theme={theme} />
          )}
        </Space>
      </Container>
    </div>
  );
};

export default SocialMedia;
